import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useTranslations();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  const navLinks = [{
    name: t('nav.home'),
    href: '#'
  }, {
    name: t('nav.howItWorks'),
    href: '#how-it-works'
  }, {
    name: t('nav.pricing'),
    href: '#pricing'
  }, {
    name: t('nav.contact'),
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-328">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329">
        <div className="flex justify-between items-center" data-id="element-330">
          {/* Logo + Language Selector */}
          <div className="flex items-center gap-4" data-id="element-331">
            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} data-id="element-332">
              <img src="https://cdn.magicpatterns.com/uploads/cw4DwFLznDxNXMB79xGgQt/Asset_21x.png" alt="Brixen Credit" className="h-8 md:h-10 w-auto" data-id="element-333" />
            </div>

            {/* Language Toggle - Desktop */}
            <div className="hidden md:flex items-center gap-1 text-sm font-medium border-l border-gray-200 pl-4" data-id="element-334">
              <button onClick={() => setLang('es')} className={`px-2 py-1 rounded transition-colors ${lang === 'es' ? 'text-purple-600 font-bold' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-335">
                ES
              </button>
              <span className="text-gray-300" data-id="element-336">|</span>
              <button onClick={() => setLang('en')} className={`px-2 py-1 rounded transition-colors ${lang === 'en' ? 'text-purple-600 font-bold' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-337">
                EN
              </button>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-338">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-purple-600 transition-colors" data-id="element-339">
                {link.name}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-340">
            <Button variant="primary" size="sm" onClick={scrollToContact} data-id="element-341">
              {t('nav.getStarted')}
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-342">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none p-2" aria-label="Toggle menu" data-id="element-343">
              {isOpen ? <X className="h-6 w-6" data-id="element-344" /> : <Menu className="h-6 w-6" data-id="element-345" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-346">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-347">
            {/* Language Toggle - Mobile */}
            <div className="flex items-center justify-center gap-2 py-3 mb-2" data-id="element-348">
              <button onClick={() => setLang('es')} className={`px-4 py-2 rounded-lg transition-colors ${lang === 'es' ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-700'}`} data-id="element-349">
                Español
              </button>
              <button onClick={() => setLang('en')} className={`px-4 py-2 rounded-lg transition-colors ${lang === 'en' ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-700'}`} data-id="element-350">
                English
              </button>
            </div>

            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-purple-600 hover:bg-purple-50 rounded-md transition-colors" onClick={() => setIsOpen(false)} data-id="element-351">
                {link.name}
              </a>)}

            <div className="mt-4 px-3" data-id="element-352">
              <Button variant="primary" fullWidth onClick={() => {
            setIsOpen(false);
            scrollToContact();
          }} data-id="element-353">
                {t('nav.getStarted')}
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}